import { createSlice } from "@reduxjs/toolkit";
import {
  getJobApplications,
  getJobApplicationById,
  deleteJobApplication,
} from "./thunk";

const initialState = {
  applications: [],
  selectedApplication: null,
  loading: false,
  error: null,
  totalCount: 0,
  totalPages: 1,
  currentPage: 1,
};

const JobApplicationSlice = createSlice({
  name: "jobApplication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ✅ GET ALL
    builder
      .addCase(getJobApplications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getJobApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.applications = action.payload.data || [];
        state.totalCount =
          action.payload.responseDetails?.totalCount || 0;
        state.totalPages =
          action.payload.responseDetails?.pagination?.totalPages || 1;
      })
      .addCase(getJobApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    // ✅ GET ONE
    builder.addCase(getJobApplicationById.fulfilled, (state, action) => {
      state.selectedApplication = action.payload;
    });

    // ✅ DELETE
    builder.addCase(deleteJobApplication.fulfilled, (state, action) => {
      state.applications = state.applications.filter(
        (item) => item.id.toString() !== action.payload.id.toString()
      );
    });
  },
});

export default JobApplicationSlice.reducer;